import * as React from "react";
import { RouteComponentProps } from "react-router";

export class RouteHelper {
    /**
     * Used to move "up" a level in the routing, e.g. from /a/b to /a
     * @param component Normally "this as any"
     * @example RouteHelper.up(this as any);
     */
    static up(component: React.Component<Partial<RouteComponentProps>, any>): void {
        component.props.history.push(component.props.match.url.substr(0, component.props.match.url.lastIndexOf("/")));
    }

    /**
     * Used to move "down" one or more levels in the routing, e.g. from /a to /a/b
     * @param component Normally "this as any"
     * @param nextRoute The values to append to the current route with no preceeding or trailing slash (/)
     * @example RouteHelper.down(this as any, "b");
     */
    static down(component: React.Component<Partial<RouteComponentProps>, any>, nextRoute: string | number): void {
        component.props.history.push(`${component.props.match.url}/${nextRoute}`);
    }
}